import type { AssetContext } from "../engine/context";

/** Format an instrument's level for its kind (yield %, $ price, index level). */
export function formatLevel(ctx: AssetContext): string {
  const { price, def } = ctx;
  if (def.kind === "rate") return `${price.toFixed(2)}%`;
  if (def.kind === "commodity") return `$${price.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
  if (def.kind === "bond") return `$${price.toFixed(2)}`;
  // Dollar-index-style levels: two decimals, no currency symbol.
  if (def.kind === "index") return price.toFixed(2);
  // Equity index levels: no cents.
  return price.toLocaleString("en-US", { maximumFractionDigits: 0 });
}

/** Signed percentage, e.g. +5.3% / −8.1%. */
export function signedPct(fraction: number, digits = 1): string {
  const pct = fraction * 100;
  const sign = pct >= 0 ? "+" : "−";
  return `${sign}${Math.abs(pct).toFixed(digits)}%`;
}

/** Signed Sharpe with two decimals, using a real minus glyph. */
export function signedSharpe(s: number): string {
  const sign = s >= 0 ? "+" : "−";
  return `${sign}${Math.abs(s).toFixed(2)}`;
}

export function formatAsOf(epochMs: number): string {
  // Worker OHLCV bar timestamps are already in milliseconds.
  const d = new Date(epochMs);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function formatClock(ms: number): string {
  return new Date(ms).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
}
